export default __webpack_public_path__ + "static/media/plain-sticker-N.3be59e03.png";